import { useEffect, useState } from "react";

import { Button } from "primereact/button";
import { Chart } from "primereact/chart";

import ChartDataLabels from 'chartjs-plugin-datalabels';

const options = {
    maintainAspectRatio: false,
    plugins: {
        datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value) => {
                return Intl.NumberFormat("pt-BR", {
                      maximumFractionDigits: 2,
                    }).format(value);
              },
            font: {
                size: 14,
                weight: 'bold',
            },
            color: "#2c3e50"
        }
    },
}

export default function RevisaoGraficoSetorTipoDefeito({ data = [], defeito, months, setor, tipo = 1 }) {
    const [chartData, setChartData] = useState({});
    const [col, setCol] = useState(tipo === 1 ? "p-col-4" : "p-col-6");

    useEffect(() => {
        let values = [];

        let descricao = '';

        months.forEach((item, index) => {
            let filteredData = data.filter((element) => {
                return defeito.includes(element.cod_defeito) && parseInt(element.mes) === index + 1 && setor === element.cod_defeitotipo;
            });

            if(filteredData.length) {
                descricao = filteredData[0].descricao;
            }

            let total = 0;
            filteredData.forEach((item) => {
                total += parseFloat(item.soma);
            });

            values.push(total);
        });
        
        const _chartData = {
            labels: months,
            datasets: [
                {
                    label: `TOTAL DE DEFEITOS POR MÊS - ${descricao}`,
                    data: values,
                    backgroundColor: "#2ecc71",
                    borderColor: "#2ecc71"
                }
            ]
        }

        setChartData(_chartData);
    }, [data, defeito, months, setor]);

    return (
        <div className={col}>
            <Button
                icon="pi pi-search"
                onClick={() => {
                    setCol(col === "p-col-4" ? "p-col-10" : "p-col-4")
                }}
            />
            <Chart 
                data={chartData}
                height="350px"
                width="100%"
                options={options}
                plugins={[ChartDataLabels]}
                type={tipo === 1 ? "line" : "bar"}
            />
        </div>
    )
}